import { createFileRoute } from '@tanstack/react-router'
import ProjectSettingsPage from '@/spa/pages/projects/ProjectSettingsPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/settings')({
  component: ProjectSettingsPage,
  errorComponent: routeErrorComponent,
})
